import React from "react";
import Tr from "./Tr"; // Import the row component for each entry in the table

// Table component to display data in a tabular format
export default function Table({
  data, // Data to be displayed in the table
  onEdit, // Function to handle editing an entry
  onDelete, // Function to handle deleting an entry
  isAllowedToEditOrDelete, // Flag to determine if the user can edit or delete
}) {
  return (
    <>
      <div className="row justify-content-md-center">
        <div className="col-sm-10">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Color Hex Code</th>
                <th scope="col">Transparency</th>
                <th scope="col">Stroke</th>
                <th scope="col">Options</th>
              </tr>
            </thead>

            <tbody>
              {/* Check if data array is empty */}
              {data.length === 0 ? (
                <tr>
                  <td colSpan={4}>No data found....</td> {/* Display message if no data */}
                </tr>
              ) : (
                // Map through the data and create a row for each entry
                data.map((d, index) => (
                  <Tr
                    key={index} // Unique key for each row
                    id={d.layer_style_color_id} // Unique identifier for the row
                    color_hex_code={d.color_hex_code} // Color hex code
                    transparency={d.transparency} // Transparency value
                    stroke={d.stroke} // Stroke value
                    onEdit={onEdit} // Pass edit handler
                    onDelete={onDelete} // Pass delete handler
                    isAllowedToEditOrDelete={isAllowedToEditOrDelete} // Pass edit/delete permission flag
                  />
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
